module.exports = __webpack_public_path__ + "static/img/turntable-new.b7dd45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/turntable-new.png
// module id = OIBD
// module chunks = 215